import { createSelector } from "reselect";
import { ApplicationStateInterface } from "../../../../../app/duck/types";


const extractFilteredURL = (state: ApplicationStateInterface): string[] => {
    return state.simulatorBeta.filteredUrl;
};
export const getfilteredUrl = createSelector(extractFilteredURL, (filteredUrl: string[]) => filteredUrl);
